// Copyright (c) 2026 by Audere

import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { RootState } from "../store";

export type State = {
  email: string;
  name: string;
  picture: string | null;
  credentials: string;
  token: string;
  expires: string;
};

const authSlice = createSlice({
  name: "auth",
  initialState: {
    email: "",
    name: "",
    picture: null,
    credentials: "",
    token: "",
    expires: "",
  } as State,
  reducers: {
    setCredentials: (state: State, action: PayloadAction<State>) => {
      state.email = action.payload.email;
      state.name = action.payload.name;
      state.picture = action.payload.picture;
      state.credentials = action.payload.credentials;
      state.token = action.payload.token;
      state.expires = action.payload.expires;
    },
    logOut: (state: State, _action: PayloadAction<void>) => {
      state.email = "";
      state.name = "";
      state.picture = null;
      state.credentials = "";
      state.token = "";
      state.expires = "";
    },
  },
});

export const { setCredentials, logOut } = authSlice.actions;

export default authSlice.reducer;

export const selectCurrentEmail = (state: RootState) => state.auth.email;
export const selectCurrentName = (state: RootState) => state.auth.name;
export const selectCurrentToken = (state: RootState) => state.auth.token;
export const selectCurrentExpires = (state: RootState) => state.auth.expires;
